import { RouteComponentProps } from "@reach/router";
import Layout from "../layout/Layout";
import { EntityNames } from "../../../enums/EntityNames";
import DisposalsPickList from "../List/DisposalsPickList";

export default function DisposalsPickingPage(props: RouteComponentProps) {
    return (
        <Layout entityName={EntityNames.pickList} pageTitle={`Pick List`} data={{}} showBackButton={true} showBreadcrumb={false} canScroll={true}>
            <DisposalsPickList />
        </Layout>
    )
}